"use strict";
exports.__esModule = true;
exports.checkLuhn = void 0;
function checkLuhn(cardNumber) {
    var len = cardNumber.length;
    var parity = len % 2;
    var sum = 0;
    for (var i = len - 1; i >= 0; i -= 1) {
        var digit = parseInt(cardNumber.charAt(i), 10);
        if (i % 2 === parity) {
            digit *= 2;
        }
        if (digit > 9) {
            digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 === 0;
}
exports.checkLuhn = checkLuhn;
//# sourceMappingURL=luhn.js.map